import { RagLevel } from '../types'

export const ragBg: Record<RagLevel, string> = {
  good: 'bg-rag-goodBg',
  medium: 'bg-rag-mediumBg',
  bad: 'bg-rag-badBg',
}

export const ragText: Record<RagLevel, string> = {
  good: 'text-rag-good',
  medium: 'text-rag-mediumDeep',
  bad: 'text-rag-bad',
}

export const ragDot: Record<RagLevel, string> = {
  good: 'bg-rag-good',
  medium: 'bg-rag-medium',
  bad: 'bg-rag-bad',
}

export const ragLabel: Record<RagLevel, string> = {
  good: 'Good',
  medium: 'Tight',
  bad: 'Bad',
}

/**
 * Classes for a day that met a target. 'gold' replaces the RAG tint with a
 * gold square; 'pulse' keeps the RAG tint and adds a throbbing gold ring
 * (only where the viewer hasn't asked for reduced motion).
 */
export function targetClasses(style: 'gold' | 'pulse'): string {
  return style === 'gold'
    ? 'bg-gold-bg ring-1 ring-gold'
    : 'ring-2 ring-gold motion-safe:animate-throb'
}

/**
 * Swatch classes for a target in the sidebar and legend. These are solid gold
 * rather than the calendar's pale fill — at 12px the pale tint reads as white,
 * and the other legend dots are solid too.
 */
export const targetDot: Record<'gold' | 'pulse', string> = {
  gold: 'bg-gold',
  pulse: 'ring-2 ring-gold',
}

/** True when the target style overrides the RAG background. */
export function targetReplacesBg(style: 'gold' | 'pulse'): boolean {
  return style === 'gold'
}
